import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupDisbandContentProps } from './msg-group-disband-content';
import { MsgGroupDisbandContent } from './msg-group-disband-content';

export interface MsgGroupDisbandProps extends MsgGroupDisbandContentProps {}

export const MsgGroupDisband = memo(function MsgGroupDisband({ message }: MsgGroupDisbandProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupDisbandContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
